import BasePointManager from "../../../../../../src/managers/BasePointManager";
import { Coord, RedPointRadianInfo } from "../../../../../../src/types/Interface";
import { eventBus, EnumEventBus } from "../EventBus";
import { CIRCLE_RADIUS, INITIAL_RADIANS, INITIAL_INTERSEC_RADIUS } from "../../types/Config";
import { generateChordPoints } from "./helpers/pointerHelper";


export default class PointManager extends BasePointManager {
	private intersecLength: number = INITIAL_INTERSEC_RADIUS;
	private chordPoints: Coord[] = [];

	constructor(cCoord: Coord) {
		super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS);
		this.setCoord();
		this.draw();

		this.chordPoints = this.getInitialChordPoints();
		eventBus.on(EnumEventBus.moveCircumPoint, (v: number) => this.handleMoveCircumPointSlider(v));
		eventBus.on(EnumEventBus.moveChord, (v: number) => this.handleMoveChord(v));
	}
	getInitialChordPoints = () => generateChordPoints(this.cCoord, CIRCLE_RADIUS, this.getRadians()[0], INITIAL_INTERSEC_RADIUS);
	getChordPoints = () => this.chordPoints;

	setRadian(pointInfoArr: RedPointRadianInfo[], isSlider?: boolean): void {
		const pointARadian = pointInfoArr[0].radian;
		this.chordPoints = generateChordPoints(this.cCoord, CIRCLE_RADIUS, pointARadian, this.intersecLength);
		this._setRadian(pointInfoArr, isSlider);
	}
	private getCurrRedPointInfo() {
		const pointA = this.getRedPoints()[0];
		const pointARadian = this.getRadians()[0];
		const pointInfo = { pTag: pointA.tag, radian: pointARadian }
		return [pointInfo];
	}
		private handleMoveCircumPointSlider(v: number) {
		const points = this.getRedPoints();
		const refRadians = this.getRefRadians();
		const radian = refRadians[0] + Math.PI / 90 * v;
		const pointInfo: RedPointRadianInfo = { pTag: points[0].tag, radian }
		this.setRadian([pointInfo], true);
	}
	private handleMoveChord(v: number) {
		this.intersecLength = v * .45 + INITIAL_INTERSEC_RADIUS;
		const pointInfo = this.getCurrRedPointInfo();
		this.setRadian(pointInfo, true);
	}
}